import type { WaveEventConfig } from './WaveEventConfig';

export const DEER_WAVE_CONFIG: WaveEventConfig = {
  id: 'deer_wave',
  displayName: 'Волна Оленей',
  bossType: 'wave_event',

  enemyId: 'deer',
  // Олень 8hp + speedHpMultiplier 2.75 (ускоряется при низком hp).
  // МАЛО — не 18-25 как волны 1-hp врагов: 8×8=64hp суммарно + ускорение = уже серьёзно.
  enemyCount: 8,
  // МЕДЛЕННЫЙ спавн — олени крупные (70px) и опасные, пачкой = свалка у правого края.
  // Другой ритм волны: накатывают группами, а не толпа сразу.
  spawnIntervalMs: 400,

  introText: 'ВОЛНА: ОЛЕНИ',
  victoryText: 'ВОЛНА ОТРАЖЕНА',
};
